export default "__VITE_ASSET__cf80e823__"